"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkClaims = exports.decodeJwtWeb = exports.decodeJwtServer = exports.getUserClaimsWeb = exports.SESSION_USER_CLAIMS = void 0;
exports.checkClaimsWeb = checkClaimsWeb;
exports.isFullAccessGiven = isFullAccessGiven;
exports.findClaimFromType = findClaimFromType;
const commonUtils_1 = require("../commonUtils");
const availableClaims_1 = require("./availableClaims");
exports.SESSION_USER_CLAIMS = 'user_claims';
const getUserClaimsWeb = () => {
    const claimsString = localStorage.getItem(exports.SESSION_USER_CLAIMS);
    if (!claimsString) {
        return {};
    }
    const claims = JSON.parse(claimsString);
    return claims;
};
exports.getUserClaimsWeb = getUserClaimsWeb;
const decodeJwtServer = (token) => {
    if (!token) {
        return {};
    }
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
};
exports.decodeJwtServer = decodeJwtServer;
const decodeJwtWeb = (token) => {
    if (!token) {
        return {};
    }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window
        .atob(base64)
        .split('')
        .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
    return JSON.parse(jsonPayload);
};
exports.decodeJwtWeb = decodeJwtWeb;
function checkClaimsWeb(paths, claims) {
    const userClaims = (0, exports.getUserClaimsWeb)();
    if (!userClaims) {
        return false;
    }
    return (0, exports.checkClaims)(userClaims, paths, claims);
}
const checkClaims = (userClaims, paths, claims) => {
    if (isFullAccessGiven(userClaims)) {
        return true;
    }
    let allowedClaimsCounter = 0;
    for (const claim of claims) {
        const claimObj = availableClaims_1.availableClaims.filter((item) => item.claimType === claim);
        if (claimObj.length === 0) {
            (0, commonUtils_1.spErrorTags)(`Claim not found in available claims: ${claim}`, [
                'claims',
            ]);
            return false;
        }
        const claimId = claimObj[0].id;
        let allowedPathsCounter = 0;
        for (const path of paths) {
            let allowedPath = 0;
            const pathArray = buildPathIntoArrays(path);
            for (const pathSubPart of pathArray) {
                const userClaimsForPart = userClaims[pathSubPart];
                let claimAllowedForSubPart = 0;
                if (userClaimsForPart) {
                    claimAllowedForSubPart = Number.parseInt(userClaimsForPart[claimId], 10);
                }
                if (claimAllowedForSubPart === 0) {
                    claimAllowedForSubPart = checkWildcardClaims(userClaims, pathSubPart, claimId);
                }
                allowedPath = allowedPath === 1 ? 1 : claimAllowedForSubPart;
                if (claimAllowedForSubPart === 2) {
                    return false;
                }
            }
            allowedPathsCounter += allowedPath;
        }
        if (allowedPathsCounter === paths.length) {
            allowedClaimsCounter++;
        }
    }
    if (allowedClaimsCounter === claims.length) {
        return true;
    }
    return false;
};
exports.checkClaims = checkClaims;
function checkWildcardClaims(userClaims, path, claimId) {
    // only allowing wildcard claims for itinerary
    if ((path.match(/\//g) || []).length === 2) {
        // replace middle part with x
        const secondSlash = path.indexOf('/', 1);
        path = '/x' + path.substring(secondSlash);
        const userClaimsWildcard = userClaims[path];
        return userClaimsWildcard
            ? Number.parseInt(userClaimsWildcard[claimId], 10) || 0
            : 0;
    }
    return 0;
}
function isFullAccessGiven(userClaims) {
    const rootClaims = userClaims['/'];
    if (!rootClaims) {
        return false;
    }
    return rootClaims[0] === '1';
}
function buildPathIntoArrays(path) {
    if (path === '/') {
        return ['/'];
    }
    const parts = path.split('/'); // Split the path into parts
    const paths = parts.reduce((carry, item) => {
        const last = carry[carry.length - 1] ?? '';
        if (last.endsWith('/')) {
            carry.push(last + item);
            return carry;
        }
        else {
            carry.push(last + '/' + item);
            return carry;
        }
    }, []);
    // reverse array so that the longest path is first
    return paths.reverse();
}
function findClaimFromType(type) {
    return availableClaims_1.availableClaims.find((claim) => claim.claimType === type);
}
